import * as React from "react";
import { Text, StyleSheet, TouchableOpacity, View } from "react-native";
import Colors from "../utilities/Color.js";

export default function GenericButton({
  buttonText,
  buttonTextColor = Colors.DARKGRAY,
  buttonTextSize = 14,
  onPress,
  buttonWidth = 270,
  buttonColor = Colors.YELLOW,
  buttonHeight = 50,
  borderWidth = 0, 
  borderColor = Colors.YELLOW
}) {
  return (
    <View style={styles.buttonContainer}>
      <TouchableOpacity
        style={[styles.submitButtonStyle, {
          backgroundColor: buttonColor,
          width: buttonWidth,
          height: buttonHeight,
          borderColor : borderColor,
          borderWidth : borderWidth, 
        }]}
        onPress={onPress}
        activeOpacity={0.5}
      >
        <Text style={[
          styles.textButtonStyle,
          {
            color: buttonTextColor,
            fontSize: buttonTextSize
          }]}>
          {buttonText}
        </Text>
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({
  submitButtonStyle: {
    borderRadius: 50,
    justifyContent: "center",
    alignSelf: "center"
  },
  textButtonStyle: {
    textAlign: "center",
    fontFamily: "montserrat-bold",
  },
  buttonContainer: {
    justifyContent: "center",
  },
});
